import React from 'react';
import { Icon, Spinner } from '@chakra-ui/react';
import { IconButton } from '@/components/ui/icon-button';
import { LuArrowDown } from 'react-icons/lu';
import { JUMP_TO_BOTTOM_BUTTON_CSS } from '@/components/ui/motion.ts';
import { COMPOSER_PORTAL_CLICK_BOUNDARY_PROPS } from '@/components/common/composer/composerConstants.ts';

const BUTTON_SIZE = 9;
const ICON_SIZE = 4.5;

interface JumpToBottomButtonProps {
	isCollapsing: boolean;
	isStreaming: boolean;
	onClick: () => void;
}

/**
 * The jump-to-latest pill. Positioning is owned by the ComposerDock `aboveBar` slot it's rendered
 * into (anchored above the bar), so this is just the button — pointerEvents auto so it stays
 * clickable inside the slot's pointer-events-none wrapper.
 */
const JumpToBottomButton: React.FC<JumpToBottomButtonProps> = (props) => {
	const { isCollapsing, isStreaming, onClick } = props;

	return (
		<IconButton
			{...COMPOSER_PORTAL_CLICK_BOUNDARY_PROPS}
			aria-label="Jump to latest message"
			type="button"
			size="sm"
			minW={BUTTON_SIZE}
			w={BUTTON_SIZE}
			h={BUTTON_SIZE}
			variant="outline"
			bg="surface.default"
			borderColor="border.default"
			boxShadow="md"
			backdropFilter="blur(2px)"
			pointerEvents="auto"
			position="relative"
			overflow="hidden"
			_hover={{ bg: 'surface.subtle' }}
			css={JUMP_TO_BOTTOM_BUTTON_CSS(isCollapsing)}
			onClick={onClick}
		>
			{isStreaming ? <Spinner size="xs" borderWidth="2px" /> : <Icon as={LuArrowDown} boxSize={ICON_SIZE} />}
		</IconButton>
	);
};

export default JumpToBottomButton;
